import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { environment } from '../../../environments/environment';
import { LabDipSearchCommand, LabDipSearchResultItem } from '../../models/production/lab-dip-search';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LabDipProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/lab-dip';

  /**
   * Search lab dips by lab dip number
   * @param command Search command with labDipNumber
   * @returns Observable with array of lab dip search results
   */
  public search(command: LabDipSearchCommand): Observable<ApiResponse<PaginatedApiResponse<LabDipSearchResultItem>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<LabDipSearchResultItem>>>(`${this.baseUrl}/search`, command);
  }
}
